/* eslint-disable */
import $ from 'jquery';
import BaseModule from './BaseModule';

export default class VehicleModelSpecification extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'VehicleModelSpecification');

    const vAccordion = $(el).find('.vms-body');
    const vTab = $(el).find('.vms-tab');

    this.activeDesktop(vTab, vAccordion);
    this.initClickEventMobile(vTab, vAccordion);
    this.initClickEventDesktop(vTab, vAccordion);
  }

  activeDesktop(vTab, vAccordion) {
    if ($(window).width() >= 768) {
      vTab.each(function() {
        $(this).children('a').eq(0).addClass('active');
      })
      vAccordion.each(function() {
        $(this).find('.vms-body-item').eq(0).addClass('active');
      })
    }
  }

  initClickEventDesktop(vTab, vAccordion) {
    vTab.on('click', 'a', function (e) {
      e.preventDefault();
      let thisTab = $(this);
      let index = thisTab.index();

      thisTab.addClass('active').siblings().removeClass('active');
      vAccordion.parents('.tab-content__item').siblings('.active').find('.vms-body-item').eq(index).addClass('active').siblings().removeClass('active').find('.vms-item-content').removeAttr('style');
    });
  }

  initClickEventMobile(vTab, vAccordion) {
    vAccordion.on('click', '.vms-item-title', function (e) {
      e.preventDefault();
      let thisParent = $(this).parent();
      let index = thisParent.index();

      vTab.children('a').eq(index).addClass('active').siblings().removeClass('active');

      if (!thisParent.hasClass('active')) {
        thisParent.find('.vms-item-content').slideDown(300, function () {
          thisParent.addClass('active');
        });

        thisParent.siblings().find('.vms-item-content').slideUp(300, function () {
          $(this).removeAttr('style');
          thisParent.siblings().removeClass('active');
        });
      } else {
        thisParent.find('.vms-item-content').slideUp(300, function () {
          thisParent.removeClass('active');
        });
      }
    });
  }
}
